module.exports = __webpack_public_path__ + "static/size_img_1-46c28c9a9db160a69a58b4ddfe25151b.png";